export const DateFormat = [
  { label: '16 Sep 2024', value: '1' },
  { label: 'Sep 16 2024', value: '2' },
  { label: '2024 Sep 16', value: '3' },
];
export const AgeOption = [
  { label: '27', value: '1' },
  { label: '25', value: '2' },
];
export const CountryOption = [
  { label: 'United States', value: '1' },
  { label: 'Canada', value: '2' },
  { label: 'United Kingdom', value: '3' },
];
export const Category = [
  { label: 'Hotels', value: '1' },
  { label: 'Villa', value: '2' },
  { label: 'Apartment', value: '3' },
  { label: 'Guest House', value: '4' },
  { label: 'Lodge', value: '5' },
];
export const tourCategory = [
  { label: 'Ecotourism', value: '1' },
  { label: 'Adventure Tour', value: '2' },
  { label: 'Group Tour', value: '3' },
  { label: 'Beach Tour', value: '4' },
  { label: 'Historical Tour', value: '5' },
];
export const StarRating = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];
export const RoomType = [
  { label: 'Queen Room', value: '1' },
  { label: 'Double Room', value: '2' },
  { label: 'Suite Room', value: '3' },
  { label: 'Family Room', value: '4' },

];
export const HotelName = [
  { label: 'Hotel Plaza Athenee', value: '1' },
  { label: 'The Luxe Haven', value: '2' },
  { label: 'The Urban Retreat', value: '3' },
  { label: 'The Grand Horizon', value: '4' },

];
export const MaximumOccupancy = [
  { label: '1-2', value: '1' },
  { label: '2-4', value: '2' },
  { label: '4-6', value: '3' },
  { label: '6-10', value: '4' },

];
export const Sleep = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
];
export const Days = [
  { label: '4 Days', value: '1' },
  { label: '6 Days', value: '2' },
  { label: '8 Days', value: '3' },
];
export const Nights = [
  { label: '4 Nights', value: '1' },
  { label: '6 Nights', value: '2' },
  { label: '8 Nights', value: '3' },
];
export const BedType = [
  { label: 'Single Bed', value: '1' },
  { label: 'Double Bed', value: '2' },
  { label: 'Queen Bed', value: '3' },
  { label: 'King Bed', value: '4' },
];
export const View = [
  { label: 'Ocean View', value: '1' },
  { label: 'Beachfront View', value: '2' },
  { label: 'Mountain View', value: '3' },
  { label: 'City View', value: '4' },
];
export const VehicleType = [
  { label: 'Sedan', value: '1' },
  { label: 'Sports', value: '2' },
  { label: 'SUV', value: '3' },
];
export const Transmission = [
  { label: 'Auto', value: '1' },
  { label: 'Manual', value: '2' },
];
export const CarBody = [
  { label: 'Sedan', value: '1' },
  { label: 'Crossover', value: '2' },
];
export const FuelType = [
  { label: 'Petrol', value: '1' },
  { label: 'Diesel', value: '2' },
  { label: 'Hybrid', value: '3' },
];
export const Door = [
  { label: '4', value: '1' },
  { label: '5', value: '2' },
];
export const Steering = [
  { label: 'Auto', value: '1' },
  { label: 'Manuel', value: '2' },
];
export const Brake = [
  { label: 'ABS', value: '1' },
  { label: 'Hydraulic Brakes', value: '2' },
];
export const Access = [
  { label: 'Remote', value: '1' },
  { label: 'Manuel', value: '2' },
];
export const PreferredClass = [
  { label: 'Economy', value: '1' },
  { label: 'Business Class', value: '2' },
];
export const FlightName = [
  { label: 'Antonov An-32', value: '1' },
  { label: 'SkyBound 102', value: '2' },
  { label: 'Nimbus 345', value: '3' },
];
export const SeatType = [
  { label: 'Economy', value: '1' },
  { label: 'Business Class', value: '2' },
];
export const CruiseType = [
  { label: 'Luxury Cruise', value: '1' },
  { label: 'Adventure Cruise', value: '2' },
];
export const ViewType = [
  { label: 'Oceanview', value: '1' },
  { label: 'Balcony', value: '2' },
];
export const CruiseName = [
  { label: 'Super Aquamarine', value: '1' },
  { label: 'Bonnie Yacht', value: '2' },
];
export const CruiseSleep = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
];
export const CruiseBedType = [
  { label: 'Single Bed', value: '1' },
  { label: 'Double Bed', value: '2' },
];
export const State = [
  { label: 'California', value: '1' },
  { label: 'Texas', value: '2' },
];
export const City = [
  { label: 'New York', value: '1' },
  { label: 'Tokyo', value: '2' },
];
export const Account = [
  { label: '500', value: '1' },
  { label: '100', value: '2' },
  { label: '2000', value: '3' },
];
